// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'

function addParams(src, width, originalSize) {
  if (!src) {
    return ''
  }

  if (src.startsWith('//')) {
    src = src.replace('//', 'https://')
  }

  src = src.replace('images.ctfassets.net', 'img.uswitch.com')
  src = src.replace('money.imgix.net', 'img.money.co.uk/s3')
  src = src.replace('uswitch-cms.imgix.net', 'img.uswitch.com/s3')

  const url = new URL(src)
  !originalSize && url.searchParams.append('w', width)
  if (!url.pathname.endsWith('.svg')) {
    url.searchParams.append('auto', 'format,compress')
  }

  return url.toString()
}

// eslint-disable-next-line no-magic-numbers
const Image = ({ src, alt, width = 1152, originalSize = false, critical, ...props }) => (
  <img
    src={critical ? addParams(src, width) : undefined}
    data-src={critical ? undefined : addParams(src, width, originalSize)}
    alt={alt}
    title={props.title}
    className={`${!critical ? 'lazyload ' : ''}${props.className}`}
  />
)

export default Image
